// @flow
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Mission List component for existing missions
Author: Deimos Space UK

Version: 1.0
*/
import React, { useEffect, useState } from "react";
import { Card, CardBody, Table, Progress, Button, Col, Row, } from "reactstrap";
import { getPetition } from "../../../../api/api";
import { Link } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import useDebounce from "../../../../hooks/useDebounce";

import { toast } from 'react-toastify';

import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';


export default function MissionList() {
  const [loading, setLoading] = useState(false)
  const [missions, setMissions] = useState([])
  const [nextUrl, setNextUrl] = useState('')
  const [previousUrl, setPreviousUrl] = useState('')
  const [search, setSearch] = useState('')
  const debouncedSearchTerm = useDebounce(search, 1000);

  useEffect(() => {
    if (debouncedSearchTerm) {

      getPetition(`/api/missions?draft=false&name=${debouncedSearchTerm}`)
        .then((data) => {
          if (data.missions) {
            setMissions(data.missions)
            setNextUrl(data.next_url)
            setPreviousUrl(data.prev_url)
          }
          else {
            setMissions([])
          }
          setLoading(false)
        })
        .catch((error) => {
          toast.warning('No mission found')

        })
    } else {

      getPetition(`/api/missions?draft=false`)
        .then((data) => {
          if (data.missions) {
            setMissions(data.missions)
            setNextUrl(data.next_url)
            setPreviousUrl(data.prev_url)
          }
          else {
            setMissions([])
          }
          setLoading(false)
        })
        .catch((error) => {
          toast.warning('No mission found')
        })
    }
  }, [debouncedSearchTerm])





  useEffect(() => {
    setLoading(true)

    getPetition('/api/missions?draft=false')
      .then((data) => {
        if (data.missions) {
          setMissions(data.missions)
          setNextUrl(data.next_url)
          setPreviousUrl(data.prev_url)
        }
        else {
          setMissions([])
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [])

  const fetchNextData = () => {
    setLoading(true)
    getPetition(nextUrl)
      .then((data) => {
        if (data.missions) {
          setMissions(data.missions)
          setNextUrl(data.next_url)
          setPreviousUrl(data.prev_url)
        }
        else {
          setMissions([])
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const fetchPreviousData = () => {
    setLoading(true)
    getPetition(previousUrl)
      .then((data) => {
        if (data.missions) {
          setMissions(data.missions)
          setNextUrl(data.next_url)
          setPreviousUrl(data.prev_url)
        }
        else {
          setMissions([])
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const getTimeLine = (time) => {
    if (!time) return 0
    let timeLine = time
    return (Math.round(timeLine * 100))
  }

  const formatDate = (date) => {
    const dateObj = new Date(date)
    const month = dateObj.getMonth() + 1
    const day = dateObj.getDate()
    const year = dateObj.getFullYear()
    return `${day}/${month}/${year}`
  }

  const formatCapacity = (capacity) => {
    if (!capacity) return 0
    // capcity is a long decimal numer transform it to eponential an return it 
    return capacity.toExponential(2)
  }


  if (loading) {
    return <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
      <Spinner animation="border" />
    </div>
  }

  return (


    <Card>
      <CardBody>
        <Row>
          <Col md={8}>
            <h4 style={{ color: '#003247' }} className="header-title">MISSION LIST</h4>
          </Col>
          <Col md={4}>
            <Form.Control
              placeholder="Search by mission name"
              style={{ marginBottom: '10px' }}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </Col>
        </Row>
        <Table className="mb-0">
          <thead>
            <tr>
              <th style={{ color: '#003247' }}>Id</th>
              <th style={{ color: '#003247' }}>Mission</th>
              <th style={{ color: '#003247' }}>Start Date</th>
              <th style={{ color: '#003247' }}>End Date</th>
              <th style={{ justifyContent: 'center', alignItems: 'center', color: '#003247' }} >Total minimum capacity</th>
              <th style={{ justifyContent: 'center', alignItems: 'center', color: '#003247' }} >Total maximum capacity</th>
              <th style={{ color: '#003247' }}>Timeline</th>
              <th style={{ color: '#003247' }}>Version</th>
              <th style={{ color: '#003247' }}>

                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {missions.map((record, index) => {
              return (
                <tr key={index}>
                  <td>{record.id}</td>
                  <td>{record.name}</td>
                  <td>{formatDate(record.start_date)}</td>
                  <td>{formatDate(record.end_date)}</td>
                  <td style={{ justifyContent: 'center', alignItems: 'center', }}>{formatCapacity(record.total_minimum_capacity)}</td>
                  <td style={{ justifyContent: 'center', alignItems: 'center', }}>{formatCapacity(record.total_maximum_capacity)}</td>
                  <td>
                    {" "}
                    <Progress
                      value={getTimeLine(record.timeline)}
                      style={{ height: "3px", marginTop: 10 }}
                      color={'#003247'}
                    />
                  </td>
                  <td>{record.version}</td>
                 
                  <td className="table-action" style={{ width: "90px" }}>
                    <OverlayTrigger
                      key={'right'}
                      placement={'left'}
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                          Edit mission
                        </Tooltip>
                      }>
                      <Link className="action-icon" to={`/impact-evaluation/clone/${record.id}`}>
                        <i className="dripicons-pencil"></i>
                      </Link>
                    </OverlayTrigger>
                    <OverlayTrigger
                      key={'right'}
                      placement={'left'}
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                          Mission detail
                        </Tooltip>
                      }>
                      <Link className="action-icon" to={`/mission-detail/${record.id}`}>
                        <i className=" dripicons-search"></i>
                      </Link>
                    </OverlayTrigger>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <div style={{ paddingTop: '20px', paddingBottom: '20px', display: 'flex', gap: '10px' }}>
          <Button style={{ background: '#003247', borderColor: '#003247' }} disabled={previousUrl === null} onClick={() => fetchPreviousData()}>
            Previous
          </Button>
          <Button style={{ background: '#003247', borderColor: '#003247' }} disabled={nextUrl === null} onClick={() => fetchNextData()} >
            Next
          </Button>
        </div>

      </CardBody>
    </Card>

  );
}
